import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';
import { RoomLayoutState } from '../resource/types';

export const roomLayoutState = (state: RootState): RoomLayoutState => state.roomLayout;

export const selectCurrentRoomLayout = createSelector([roomLayoutState], state => state.room_layout);
